<template>
  <div class="page landing">
    <!-- banner -->
    <section class="banner"></section>

    <section class="content">
      <!-- 标语 -->
      <div class="slogan">最长可分12期慢慢还</div>

      <!-- 表单内容 -->
      <form ref="form" class="form">
        <div class="form-item">
          <nd-input
            name="mobile"
            v-model="form.mobile"
            placeholder="输入手机号，立马借款"
            type="pure-number"
            maxLength="11"
            @blur="mobileBlur"
            @focus="mobileFocus"
          >
          </nd-input>
        </div>

        <div class="form-item">
          <nd-input
            name="smsCode"
            v-model="form.smsCode"
            placeholder="请输入验证码"
            type="pure-number"
            maxLength="6"
            @blur="codeBlur"
            @focus="codeFocus"
          >
          </nd-input>

          <nd-send-code
            class="send-code"
            :disabled="smsDisabled"
            :sendCode="sendCodeHandler"
          />
        </div>
        <div class="agree">
          <van-checkbox v-model="agreeChecked" checked-color="#736CCC">
            请您阅读并同意
            <span class="highlight" @click.stop="protocolPopup = true">用户服务协议</span>
          </van-checkbox>
        </div>
        <div class="btn-name">
          <div class="btn" @click="goLoan">
            <span>立即借款</span>
          </div>
        </div>
      </form>

      <!-- 特色 -->
      <div class="property">
        <div class="property-item">
          <div class="item-icon">
            <img
              src="https://static.ndmicro.com/tmd/landing/straight/images/icon01_w.png"
              srcset="
                                https://static.ndmicro.com/tmd/landing/straight/images/icon01_w@2x.png 2x,
                                https://static.ndmicro.com/tmd/landing/straight/images/icon01_w@3x.png 3x
                            "
            />
          </div>

          <div class="item-content">
            <div>快速审批</div>
            <div>最快5分钟放款</div>
          </div>
        </div>
        <div class="property-item">
          <div class="item-icon">
            <img
              src="https://static.ndmicro.com/tmd/landing/straight/images/icon_02_w.png"
              srcset="
                                https://static.ndmicro.com/tmd/landing/straight/images/icon_02_w@2x.png 2x,
                                https://static.ndmicro.com/tmd/landing/straight/images/icon_02_w@3x.png 3x
                            "
            />
          </div>

          <div class="item-content">
            <div>分期偿还</div>
            <div>可分12期偿还</div>
          </div>
        </div>
        <div class="property-item">
          <div class="item-icon">
            <img
              src="https://static.ndmicro.com/tmd/landing/straight/images/icon_03_w.png"
              srcset="
                                https://static.ndmicro.com/tmd/landing/straight/images/icon_03_w@2x.png 2x,
                                https://static.ndmicro.com/tmd/landing/straight/images/icon_03_w@3x.png 3x
                            "
            />
          </div>

          <div class="item-content">
            <div>放心使用</div>
            <div>正规持牌机构</div>
          </div>
        </div>
      </div>

      <!-- 公司信息 -->
      <section class="company">
        <p>资金来源：由正规持牌金融机构提供</p>
        <p>请合理贷款，理性消费，避免逾期</p>
        <p>天美贷在发放贷款前不会收取任何费用</p>
        <p>联系电话：400-010-0008</p>
        <p class="mt24">重庆市崇天小额贷款有限公司</p>
        <p>公司地址：重庆市南岸区南滨路22号1栋长江国际大厦33层3319室</p>
        <p>渝公网安备 50010802002638号I渝ICP备18009772号-1</p>
      </section>
    </section>

    <!-- 图片验证码弹窗 -->
    <nd-dialog
      v-model="captchaVisible"
      class="captcha-dialog"
      :footer="false"
      closeBtn
    >
      <div class="captcha-dialog-content">
        <div class="captcha-title">请输入下面的图形验证码</div>

        <div
          class="captcha-image"
          ref="canvasWrapper"
          @click="createImage"
        >
          <canvas ref="canvas"></canvas>
        </div>

        <nd-input
          class="captcha-input"
          v-model="imageCode"
          maxLength="4"
          type="number"
          placeholder=" "
        ></nd-input>

        <nd-button
          class="captcha-btn"
          :disabled="imageCode.length < 4"
          @click="verifyCode"
        >提交</nd-button>
      </div>
    </nd-dialog>

    <van-popup
      v-model="protocolPopup"
      class="protocol-popup"
      position="bottom"
    >
      <dl>
        <dt>
          用户服务协议
          <img
            src="https://static.ndmicro.com/tmd/landing/straight/images/btn_close.png"
            srcset="
                            https://static.ndmicro.com/tmd/landing/straight/images/btn_close@2x.png 2x,
                            https://static.ndmicro.com/tmd/landing/straight/images/btn_close@3x.png 3x
                        "
            @click="protocolPopup = false"
          />
        </dt>
        <dd tag="dd" v-for="(item, index) in protocols" :key="index" @click="routerToProtocol(item.path)">
          {{item.name}}
        </dd>
      </dl>
    </van-popup>

    <!-- 下载引导 -->
    <download-guide ref="downloadGuide"></download-guide>
  </div>
</template>
<script>
import { judgeClientSystem } from '@/assets/utils'
import { mapActions, mapState } from 'vuex'
import validate from '../../../components/nd-validate'
import DownloadGuide from '../../authentication/components/download-guide'
import { Popup, Checkbox } from 'vant'
import axios from '@/assets/axios'
import isIntercept from '@/assets/intercept-mixin'
import configMixins from '../configMixins'
export default {
  name: 'straight',

  mixins: [validate, configMixins],

  components: {
    DownloadGuide,
    Popup,
    VanCheckbox: Checkbox
  },

  data () {
    return {
      isIos: judgeClientSystem() === 'IOS',
      form: {
        mobile: '',
        smsCode: '',
        smsKey: ''
      },
      captchaVisible: false,
      rules: {
        mobile: [
          {
            require: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            regular: /^1[0-9]{10}$/,
            message: '手机号码格式错误，请重新输入',
            trigger: 'blur'
          }
        ],
        smsCode: [
          {
            require: true,
            message: '请输入验证码',
            trigger: 'blur'
          },
          {
            regular: /[0-9]{6}$/,
            message: '验证码错误，请重新输入',
            trigger: 'blur'
          }
        ]
      },
      channel: '',
      popupTime: 0,
      imageCode: '',
      randomArray: [],
      context: null,
      protocolPopup: false,
      protocols: [{ name: '《天美贷用户注册及服务协议》', path: '/tmd/protocol/login' }, { name: '《天美贷隐私政策》', path: '/tmd/protocol/privacy' }],
      nextNode: 'CREDIT_RESULT',
      loanList: null,
      serialNo: null,
      half: false,
      agreeChecked: false
    }
  },

  async created () {
    this.$bus.$emit('ready')
    // 获取落地页渠道
    this.channel = this.$route.query.channel || this.$storage.get('channel') || 'official'
    await isIntercept(this.channel)
  },

  computed: {
    smsDisabled () {
      const disabled = !this.validateWithoutTip({ mobile: this.rules.mobile })
      if (!disabled) {
        this.$sensors.track('general_event', {
          additinal_status: 'mobile_complete'
        })
      }
      return disabled
    },

    ...mapState('user', {
      authStatus: (state) => state.userInfo.authStatus || []
    }),
    isIosWx () {
      return judgeClientSystem() === 'IOS' && !!navigator.userAgent.toLowerCase().match(/micromessenger/i)
    }
  },
  watch: {
    'form.smsCode' (val) {
      if (val && val.length === 6) {
        this.$sensors.track('general_event', {
          additinal_status: 'code_complete'
        })
      }
    }
  },
  methods: {
    ...mapActions('user', ['sendCodeX', 'loginBySmsX', 'getUserInfoX', 'getIRR24', 'getChannelJumpX']),

    randomNumber (num) {
      var random = ''
      for (var i = 0; i < num; i++) {
        random += Math.floor(Math.random() * 10)
      }
      return random
    },

    // 点击获取验证码
    sendCodeHandler () {
      this.$report({
        id: 50018,
        args: {
          target: 'STRAIGHT'
        }
      })
      this.$sensors.track('general_event', {
        'submissions': { mobile: this.form.mobile }
      })
      return new Promise((resolve, reject) => {
        this.sendCodeX({
          mobile: this.form.mobile
        }).then(response => {
          if (response.success) {
            this.form.smsKey = response.data.smsKey
            resolve(true)
          } else {
            reject(new Error(response.msg))
          }
        })
      })
    },

    // 校验验证码
    verifyCode () {
      this.$indicator()
      setTimeout(() => {
        this.$indicator.close()
        if (this.imageCode === this.random) {
          this.$report({
            id: 50020,
            args: {
              visible: 0,
              target: 'STRAIGHT'
            }
          })
          this.captchaVisible = false
          this.$emit('captcha-passed')
        } else {
          this.$message('验证码错误')
        }
      }, 500)
    },

    createImage () {
      this.random = this.randomNumber(4)
      const ctx = this.$refs['canvas'].getContext('2d')
      ctx.clearRect(0, 0, 300, 400)
      this.$nextTick(() => {
        ctx.fillStyle = '#FF4633'
        ctx.textBaseline = 'middle'
        ctx.font = '88px DIN-Medium'

        ctx.fillText(this.random, 48, 80)
      })
    },

    // 立即借款
    async goLoan () {
      const res = this.validateWithoutTip(this.rules, (msg) =>
        this.$message(msg)
      )
      if (!res) return
      if (!this.agreeChecked) {
        return this.$message('请先勾选并同意用户服务协议')
      }
      this.$report({
        id: 50019,
        args: {
          target: 'STRAIGHT'
        }
      })
      this.$sensors.track('general_event', {
        'submissions': { mobile: this.form.mobile, smsCode: this.form.smsCode }
      })
      const response = await this.loginBySmsX(this.form)
      if (response.success) {
        this.$statistics('LOGIN')
        await this.getUserInfoX({ forceUpdate: true, checkToken: true })
        await this.getProcessType()
        this.nextStep()
      } else {
        if (response.code === '000010') {
          this.$message(response.msg)
        }
      }
    },

    // 判断用户下一步走什么流程
    async nextStep () {
      const { success, data } = await this.getChannelJumpX()
      if (success && data) {
        return this.handleLandingJump(data.type, 'straight')
      }
    },

    async getProcessType () {
      const res = await axios.post('/order/v1/biz-route', {
        channelNo: this.channel
      })
      if (res.data.success) {
        this.nextNode = res.data.data.currentNode
        this.loanList = res.data.data.loanList
        this.serialNo = res.data.data.serialNo
        this.half = res.data.data.half
      }
    },

    mobileBlur () {
      this.$report({
        id: 50016,
        args: {
          content: this.form.mobile,
          target: 'STRAIGHT'
        }
      })
    },

    codeBlur () {
      this.$report({
        id: 50017,
        args: {
          content: this.form.smsCode,
          target: 'STRAIGHT'
        }
      })
    },
    mobileFocus () {
      this.$sensors.track('general_event', {
        additinal_status: 'mobile_focus'
      })
    },
    codeFocus () {
      this.$sensors.track('general_event', {
        additinal_status: 'code_focus'
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page.landing {
    .banner {
        width: 750px;
        height: 870px;
        margin: 0 auto;
        background-image: url("https://static.ndmicro.com/tmd/landing/straight/images/img_01@2x.png");
        background-size: cover;
    }

    .content {
        width: 750px;
        // height: 1035px;
        background: linear-gradient(180deg, #8992e1 0%, #A7BFFF 100%);
        margin: -2px auto;
        .slogan {
            padding:37px 0 17px;
            margin:auto;
            // width: 289px;
            text-align: center;
            height: 45px;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 45px;
            position: relative;
            box-sizing: content-box;
            &::before,
            &::after {
                content: '';
                position: absolute;
                width: 115px;
                height: 2px;
                top:60px;
                background: #D6D2FF;
            }

            &::before {
                left: 70px;
            }

            &::after {
                right: 70px;
            }
        }

        .form {
            margin: 0 auto;
            width: 656px;
            // margin-top: 38px;

            .form-item {
                margin: 0 auto;
                width: 625px;
                height: 94px;
                line-height: 94px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                border-radius: 10px;
                background-color: #ffffff;
                padding: 0 15px 0 30px;
                margin-top: 21px;
                font-size: 33px;
                font-family: PingFang SC;
                font-weight: 400;

                .nd-input {
                    input {
                        font-size: 33px;
                        height: 50px;
                        line-height: 50px;
                    }
                }

                .form-tip.visible {
                    color: transparent;
                    opacity: 0;
                }

                .send-code {
                    height: 61px;
                    line-height: 61px;
                    width: 183px;
                    border: 1px solid #ff4633;
                    color: #ff4633;
                    background-color: white;
                    border-radius: 31px;
                    font-size: 27px;
                    flex-shrink: 0;

                    span {
                        font-size: 27px;
                    }

                    &.disabled {
                        color: @fc4;
                        border: 1px solid @fc4;
                    }
                }
            }

            .agree {
                margin: 54px 16px 0;
                height: 30px;
                font-size: 22px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 30px;
                .highlight {
                    color: #FFEA98;
                }
                /deep/.van-checkbox__icon{
                    font-size: 28px;
                    .van-icon{
                        border-color: #736CCC;
                        border-width: 2px;
                    }
                }
                /deep/.van-checkbox__label{
                    color: #FFFFFF;
                }
            }
            .btn-name {
                width: 560px;
                height: 140px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: auto;
                padding-top: 10px;
            }
            .btn {
                text-align: center;
                width: 560px;
                height: 140px;
                background-image: url("https://static.ndmicro.com/tmd/landing/straight/images/btn_jiekuan@2x.png");
                background-size: 100% 100%;
                line-height:140px;
                span{
                    font-size: 40px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #FFFFFF;
                }
            }
        }

        .property {
            display: flex;
            margin: 70px auto 0;
            padding-bottom: 75px;

            .property-item {
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;

                .item-icon {
                    width: 60px;
                    height: 60px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .item-content {
                    :first-child {
                        margin-top:18px;
                        height: 40px;
                        font-size: 28px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 40px;
                    }
                    :last-child {
                        height: 30px;
                        font-size: 22px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 30px;
                    }
                }
            }
        }
    }

    .company {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 750px;
        background: #736CCC;
        color: #B6B2E9;
        font-size: 23px;
        font-family: PingFang SC;
        font-weight: 400;
        overflow: hidden;
        box-sizing: border-box;
        padding:24px 0 24px 50px;
        p {
            line-height: 1.6em;
        }
        .mt24{
            margin-top:24px;
        }
    }

    .captcha-dialog-content {
        padding-bottom: 73px;

        .captcha-title {
            font-size: 38px;
            font-family: PingFang SC;
            font-weight: bold;
            color: @fc1;
            text-align: center;
        }

        .captcha-image {
            width: 406px;
            height: 125px;
            border-radius: 10px;
            overflow: hidden;
            margin: 0 auto;
            margin-top: 66px;
            background-image: url('https://static.ndmicro.com/tmd/landing/straight/images/icon01@2x.png');
            background-size: cover;

            canvas {
                width: 100%;
                height: 100%;
            }
        }

        .captcha-input {
            width: 406px;
            height: 94px;
            border: 1px solid rgba(170, 170, 170, 1);
            border-radius: 10px;
            margin: 0 auto;
            margin-top: 22px;
            padding-left: 25px;

            input {
                font-size: 46px;
                line-height: 60px;
                height: 60px;
                margin-top: 17px;
            }
        }

        .captcha-btn {
            width: 406px;
            height: 94px;
            line-height: 94px;
            border-radius: 10px;
            margin: 0 auto;
            margin-top: 65px;
            font-size: 40px;
            font-family: PingFang SC;
            font-weight: 600;
        }
    }
    .protocol-popup {
        background-color: transparent;
        dl {
            background-color: #fff;
            border-radius: 30px 30px 0px 0px;
            padding-bottom: 80px;
            dt {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 50px;
                height: 170px;
                font-size: 36px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                > img {
                    width: 33px;
                    height: 33px;
                }
            }
            dd {
                height: 110px;
                padding: 0 40px;
                line-height: 110px;
                font-size:30px;
                border-top: 1px solid #EEEEEE;
            }
        }
    }
}
</style>